var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"h-100",class:_vm.loading ? _vm.loadingClass:'',attrs:{"variant":_vm.variant,"disabled":_vm.loading || _vm.disable},on:{"click":_vm.onClick}},[(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_c('i',{staticClass:"fa-solid fa-trash-can"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }